<template>
  <div class="p-3 bg-white">
    <table class="w-100 table table-striped table-hover">
      <thead>
        <tr>
          <th>TRANS. ID</th>
          <th>CREATOR BY</th>
          <th>EFFECTIVE DATE</th>
          <th>STATUS</th>
          <th>ACTION</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in items" :key="index">
          <td>{{ item.trans_id }}</td>
          <td>
            <div class="d-flex align-items-center">
              <img
                :src="item.avatar"
                alt="avatar"
                class="rounded-circle mr-2"
                width="40"
                height="40"
              />
              <div>
                <div class="font-weight-bold">{{ item.name }}</div>
                <small class="text-muted">{{ item.position }}</small>
              </div>
            </div>
          </td>
          <td>{{ item.effective_date }}</td>
          <td>
            <span class="badge badge-success p-2">{{ item.status }}</span>
          </td>
          <td>
            <button
              class="btn btn-outline-primary btn-sm"
              @click="showSidebar = true"
              >Detail</button
            >
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Pagination Section -->
    <div class="mt-4 d-flex align-items-center w-100 justify-content-between">
      <p class="mb-0"
        >Total Rows: <strong class="text-black">{{ 5 }}</strong></p
      >
      <div class="d-flex justify-content-end">
        <b-form-select
          plain
          :options="limitOptions"
          style="width: 100px"
          @input="fetchData"
        ></b-form-select>
        <b-pagination
          class="mb-0 ml-2"
          @change="
            (page) => {
              fetchData()
            }
          "
          :total-rows="10"
          :per-page="10"
          first-number
          align="center"
        ></b-pagination>
      </div>
    </div>

    <!-- SIDEBAR -->
    <b-sidebar
      v-model="showSidebar"
      width="840px"
      right
      title="Detail Adjustment Running Hours"
      backdrop
      header-class="bg-white"
      body-class="p-3"
      no-close-on-backdrop
    >
      <div class="bg-white">
        <FormAdjustmentRunningHours :selectedData="{}" />
      </div>
    </b-sidebar>
  </div>
</template>

<script>
import CustomSidebar from '@/src/components/global/CustomSidebar.vue'
import { limitOptions } from '@/src/core/mock/data/optionsData'
import FormAdjustmentRunningHours from '../RunningHourNew/FormAdjustmentRunningHours.vue'

export default {
  components: { CustomSidebar, FormAdjustmentRunningHours },
  data() {
    return {
      limitOptions,
      showSidebar: false,
      items: [
        {
          trans_id: '250725008',
          name: 'Budiono Gunawan',
          position: 'Port Captain',
          effective_date: 'Tue, 22 Oct 2025',
          status: 'Approved',
          avatar: 'https://i.pravatar.cc/40?img=1',
        },
        {
          trans_id: '250603019',
          name: 'Rudi Simanjuntak',
          position: 'Technical Manager',
          effective_date: 'Tue, 15 Oct 2025',
          status: 'Approved',
          avatar: 'https://i.pravatar.cc/40?img=2',
        },
        {
          trans_id: '250603019',
          name: 'Muhammad Rozikin',
          position: 'Port Engineer',
          effective_date: 'Wed, 12 Oct 2025',
          status: 'Approved',
          avatar: 'https://i.pravatar.cc/40?img=3',
        },
        {
          trans_id: '250603019',
          name: 'Muhammad Rozikin',
          position: 'Port Engineer',
          effective_date: 'Tue, 05 Oct 2025',
          status: 'Approved',
          avatar: 'https://i.pravatar.cc/40?img=4',
        },
      ],
      totalRows: 100,
    }
  },
  methods: {
    fetchData() {},
  },
}
</script>
